import { FunnelSimple } from '@phosphor-icons/react';

export default FunnelSimple;
